/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit None/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Boolean from './Boolean/index'
import No from './No/index'
import Number from './Number/index'
import React from 'react'
import SecureString from './SecureString/index'
import String from './String/index'



/** @type {import('Simple/types.js').View} */
export default function None({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Properties/Content/Content/Content/ActiveStep/None"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let stepTypeValueData = fromData.useDataValue({ viewPath,
context: 'step',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: stepTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Boolean'}>
<Boolean
  viewPath={`${viewPath}/Boolean`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Number'}>
<Number
  viewPath={`${viewPath}/Number`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'String'}>
<String
  viewPath={`${viewPath}/String`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SecureString'}>
<SecureString
  viewPath={`${viewPath}/SecureString`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}